// Shared vocabulary for the Cases pages.
import { parseTs } from '../SecurityAlerts/model';

export const STATUSES = ['open', 'investigating', 'remediation', 'closed'];
export const STATUS_LABEL = { open: 'Open', investigating: 'Investigating', remediation: 'Remediation', closed: 'Closed' };
export const NEXT = { open: ['investigating', 'Start investigating'], investigating: ['remediation', 'Move to Remediation'], remediation: null, closed: null };
export const PRIORITIES = ['critical', 'high', 'medium', 'low'];
export const PRIORITY_LABEL = { critical: 'CRITICAL', high: 'HIGH', medium: 'MEDIUM', low: 'LOW' };
export const PRIORITY_TOKEN = { critical: 'crit', high: 'high', medium: 'med', low: 'low' };
export const OUTCOMES = [
  ['resolved', 'Resolved', 'Real incident, dealt with'],
  ['false_positive', 'False positive', 'Nothing malicious happened'],
  ['duplicate', 'Duplicate', 'Tracked in another case'],
  ['accepted_risk', 'Accepted risk', 'Known, left as is on purpose'],
];
export const OUTCOME_LABEL = Object.fromEntries(OUTCOMES.map(([v, l]) => [v, l]));
export const KC_SHORT = ['Recon', 'Weaponise', 'Deliver', 'Exploit', 'Install', 'C2', 'Act'];
export const KC_LONG = ['Reconnaissance', 'Weaponisation', 'Delivery', 'Exploitation', 'Installation', 'Command and control', 'Actions on objectives'];

// Age-based SLA target per priority (minutes): a case still open past this is overdue.
export const SLA_MINUTES = { critical: 30, high: 120, medium: 480, low: 1440 };
export const isOverdue = (c) => {
  if (c.status === 'closed') return false;
  const d = parseTs(c.created_at);
  return !!d && (Date.now() - d.getTime()) / 60000 > (SLA_MINUTES[c.priority] ?? SLA_MINUTES.medium);
};

export const caseRef = (id) => String(id || '').toUpperCase();
export const SYSTEM = 'system';

export const age = (iso) => {
  const d = parseTs(iso);
  if (!d) return '';
  const m = Math.max(0, Math.floor((Date.now() - d.getTime()) / 60000));
  if (m < 60) return `${Math.max(m, 1)} min`;
  if (m < 1440) return `${Math.floor(m / 60)} h ${m % 60 ? `${m % 60} m` : ''}`.trim();
  return `${Math.floor(m / 1440)} d`;
};
export const ago = (iso) => {
  const d = parseTs(iso);
  if (!d) return '';
  const m = Math.max(0, Math.floor((Date.now() - d.getTime()) / 60000));
  if (m < 1) return 'now';
  if (m < 60) return `${m} min`;
  if (m < 1440) return `${Math.floor(m / 60)} h`;
  return `${Math.floor(m / 1440)} d`;
};
export const stamp = (iso) => {
  const d = parseTs(iso);
  if (!d) return '';
  const today = new Date().toDateString();
  const hm = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });
  return d.toDateString() === today ? `today ${hm}` : `${d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })} ${hm}`;
};

export const furthestStage = (kc = []) => {
  let last = -1;
  kc.forEach((n, i) => { if (n > 0) last = i; });
  return last;
};
export const kcSentence = (kc = []) => {
  const i = furthestStage(kc);
  if (i < 0) return 'No ATT&CK-tagged evidence yet, so no kill-chain stage.';
  if (i === 6) return 'Actions on objectives reached: the attacker acted on what they came for.';
  return `${KC_LONG[i]} reached. No sign of ${KC_LONG[i + 1].toLowerCase()} yet.`;
};

export const initials = (name, email) => {
  const src = name || (email || '').split('@')[0];
  if (!src) return '?';
  const parts = src.split(/[\s._-]+/).filter(Boolean);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || src[0].toUpperCase();
};
